import React, { Component } from 'react';
import $ from "jquery";
import ErrorNoResultHeader from './errorNoResultHeader';
import Footer from './Footer';
import Header from "../pages/header"
import * as requestLib from '../lib/requestLib'

export default class NoResult extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };

        this.baseUrl = requestLib.getUrl();

    }

    componentWillMount() {
        $('footer').css('position', 'fixed');
    }

    render() {
        return (
            <div id="mainContainer" className="errormsg">
                {/* <ErrorNoResultHeader/>*/}
                <Header list={[]} groupList={this.props.groupList} noResult={true} />;
                <div className="noResult">
                    <div className="wrapB">
                        <h2>No results found.</h2>
                        <p>Sorry, we could not find any results for your search.</p>
                        <p> Please check your spelling or try using more general words.</p>
                        <p> If you keep having this problem please <a href={this.baseUrl + "askus"}>contact us.</a> </p>

                    </div>
                </div>
                <Footer posinone={true} />
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/NoResult.js